import React, { useEffect } from "react";
import { Stack, circularProgressClasses } from "@mui/material";
import Paper from "@mui/material/Paper";
import _ from "lodash";
import "../../context_dark.css";
import { StyledAutocompleteDark } from "../../context_components/styled_autocomplete";
import { alpha, styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import { analysisActions } from "../../../store/store";
import { useDispatch, useSelector } from "react-redux";
import ColorPicker from "../../context_components/color_picker";
import TextField from "@mui/material/TextField";
import { Chip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { store } from "../../../store/store";
import Selector from "../../context_components/selector";
import { AnalysisOptions } from "./analysisOptions";
import { Collapse } from "@mui/material";

const useAutoCompleteStyles = makeStyles({
  option: {
    fontSize: '0.875rem',
  },
});

const useChipStyles = makeStyles({
  customChip: {
    backgroundColor: 'rgba(0, 255, 255, 0.15)',
    color: "rgba(245, 245, 245, 0.75)"
  },
});

const DarkSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: "rgba(0, 255, 255, 0.65)",
    '&:hover': {
      backgroundColor: alpha("rgba(0, 255, 255, 0.65)", theme.palette.action.hoverOpacity),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: "rgba(0, 255, 255, 0.65)",
  },
}));

export default function DrilldownAnalysis(props) {
  const dispatch = useDispatch();
  const classes = useChipStyles();
  const autocomplete_classes = useAutoCompleteStyles();
  const {
    skuInfoRaw,
    brands,
    variants,
    skus
  } = useSelector(state => state.defaultTabStore);
  const {
    drillDownAnalysis,
    analysisOptions
  } = useSelector(state => state.analysisStore);
  const {
    color,
    col_100
  } = useSelector(state => state.themeStore);
  const aiStatus = analysisOptions.AI.selected;
  const hiStatus = analysisOptions.HI.selected;
  
  const StyledChip = styled(Chip)(({ theme }) => ({
    backgroundColor: col_100,
    color: "rgba(245, 245, 245, 0.75)"
  }));



  const handleDrilldownAnlaysisOptionChange = (e, type) => {
    /**
     * updating by type...
     * resetting the state, if selected item is null,
     * updating respective options & selected values based on selected option type
     */
    if (type === "brands") {
      if (e.length === 0) {
        dispatch(analysisActions.resetStateByType({
          type: "drillDownAnalysis",
          updatedState: {
            selectedBrand: [],
            selectedVariant: [],
            selectedSku: [],
            currentSelectedType: "",
            brandOptions: [],
            variantOptions: [],
            skuOptions: [],
            colors: {}
          }
        }))
      } else {
        const updatedVariantList = skuInfoRaw
          .filter(r => e.includes(r.sku_name))
          .map(r => r.sku_name + "_" + r.sub_sku_name);

        dispatch(analysisActions.setVariantDrilldown({
          analysis: "drillDownAnalysis",
          value: e.length === 0 ? [] : e,
          variantOptions: [...new Set(updatedVariantList)],
          currentSelectedType: "selectedBrand"
        }))
      }
    } else if (type === "variants") {
      if (e.length === 0) {
        const updatedState = {
          selectedVariant: [],
          selectedSku: [],
          currentSelectedType: "selectedBrand",
          variantOptions: [],
          skuOptions: [],
          colors: {}
        }

        dispatch(analysisActions.resetStateByType({
          type: "drillDownAnalysis",
          updatedState: {
            ...drillDownAnalysis,
            ...updatedState
          }
        }))
      } else {
        const updatedSkuList = skuInfoRaw
          .filter(r => e.includes(r.sku_name + "_" + r.sub_sku_name))
          .map(r => r.skus);

        dispatch(analysisActions.setSkuDrilldown({
          analysis: "drillDownAnalysis",
          value: e.length === 0 ? [] : e,
          skuOptions: [...new Set(updatedSkuList)],
          currentSelectedType: "selectedVariant"
        }))
      }
    } else if (type === "skus") {
      if (e.length === 0) {
        const updatedState = {
          selectedSku: [],
          currentSelectedType: "selectedVariant",
          skuOptions: [],
          colors: {}
        }

        dispatch(analysisActions.resetStateByType({
          type: "drillDownAnalysis",
          updatedState: {
            ...drillDownAnalysis,
            ...updatedState
          }
        }))
      } else {
        dispatch(analysisActions.setSku({
          analysis: "drillDownAnalysis",
          value: e.length === 0 ? [] : e,
          currentSelectedType: "selectedSku"
        }))
      }
    }
  }

  const renderSelectedOptions = (selectedOptions, { inputValue }) => {
    /**
     * The delete option in the chip is not configured (yet...)
     */
    let displayedOptions = selectedOptions.slice(0, 0);

    if (selectedOptions.length > 0) {
      const remainingCount = selectedOptions.length;
      const remainingOptions = `+${remainingCount}`;
      displayedOptions = displayedOptions.concat(remainingOptions);
    }

    return (
      <div>
        {displayedOptions.map((option, index) => (
          <StyledChip
            // className={chip_classes.chip}
            size="small"
            key={index}
            label={option}
            onDelete={() => handleDrilldownAnlaysisOptionChange(option, "")}
          />
        ))}
      </div>
    );
  };

  const handleRemoveOption = (item) => {
    /**
     * removing color against selected item from color object
     * simultaneously updating the selected values object by current selected type
     */
    const colors = { ...drillDownAnalysis.colors };
    delete colors[item];
    dispatch(analysisActions.removeOption({
      analysis: "drillDownAnalysis",
      value: drillDownAnalysis[drillDownAnalysis.currentSelectedType].filter(r => r !== item),
      currentSelectedType: drillDownAnalysis.currentSelectedType,
      colors: colors
    }));
  }

  const currentSelection = drillDownAnalysis[drillDownAnalysis.currentSelectedType];

  return (
    <Stack
      spacing={2}
      sx={{ dispaly: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <Stack spacing={0}>
        {brands.length > 0 &&
          <StyledAutocompleteDark
            sx={{ width: "15rem" }}
            classes={{
              option: autocomplete_classes.option,
            }}
            id="size-small-outlined-multi"
            size="small"
            noOptionsText="Loading..."
            value={drillDownAnalysis.selectedBrand}
            componentsProps={{ popper: { style: { width: 'fit-content' } } }}
            options={brands}
            getOptionLabel={(option) => option}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder={`Brands   ( ${brands.length} )`}
              />
            )}
            renderTags={renderSelectedOptions}
            multiple
            onChange={(event, values) => handleDrilldownAnlaysisOptionChange(values, "brands")}
          />}

        {drillDownAnalysis.variantOptions.length > 0 &&
          <StyledAutocompleteDark
            sx={{ width: "15rem" }}
            classes={{
              option: autocomplete_classes.option,
            }}
            id="size-small-outlined-multi"
            size="small"
            noOptionsText="Loading..."
            value={drillDownAnalysis.selectedVariant}
            componentsProps={{ popper: { style: { width: 'fit-content' } } }}
            options={drillDownAnalysis.variantOptions}
            getOptionLabel={(option) => option}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder={`Variants   ( ${drillDownAnalysis.variantOptions.length} )`}
              />
            )}
            renderTags={renderSelectedOptions}
            multiple
            onChange={(event, values) => handleDrilldownAnlaysisOptionChange(values, "variants")}
          />}

        {drillDownAnalysis.skuOptions.length > 0 &&
          <StyledAutocompleteDark
            sx={{ width: "15rem" }}
            classes={{
              option: autocomplete_classes.option,
            }}
            id="size-small-outlined-multi"
            size="small"
            noOptionsText="Loading..."
            value={drillDownAnalysis.selectedSku}
            componentsProps={{ popper: { style: { width: 'fit-content' } } }}
            options={drillDownAnalysis.skuOptions}
            getOptionLabel={(option) => option}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder={`Skus   ( ${drillDownAnalysis.skuOptions.length} )`}
              />
            )}
            renderTags={renderSelectedOptions}
            multiple
            onChange={(event, values) => handleDrilldownAnlaysisOptionChange(values, "skus")}
          />}
      </Stack>


      {currentSelection && currentSelection.map(item => (
        <Selector
          type="drillDownAnalysis"
          value={item}
          onClick={handleRemoveOption}
        />
      ))}

      {/* Analysis Options */}
      <Collapse in={hiStatus} timeout={350} unmountOnExit>
        <AnalysisOptions />
      </Collapse>
    </Stack>
  )
}